// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconBook,
    IconUserCircle 
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};
// ==============================|| APPLICATION MENU ITEMS ||============================== //

const cours = {
    id: 'cours',
    title: ["E. ", <FormattedMessage id="cours" />],
    type: 'group',
    icon: <IconBook />, // Use a valid icon component here
    children: [
        
                {
                    id: 'dureeCours',
                    title: ["1. ",<FormattedMessage id="duree_cours" />],
                    type: 'item',
                    url: '/cours/dureeCoursSchools'
                    // '/user/social-profile/posts'
                },

                {
                    id: 'groupeCours1',
                    title: ["2. ",<FormattedMessage id="domaineCours" />],
                    type: 'item',
                    url: '/cours/coursDomaine'
                },

                {
                    id: 'turnos',
                    title: ["3. ",<FormattedMessage id="turno" />],
                    type: 'item',
                    url: '/turno'
                    // '/user/social-profile/posts'
                },

                {
                    id: 'niveauAcademiq',
                    title: ["4. ",<FormattedMessage id="enregistrer_classes" />],
                    type: 'item',
                    url: '/anofrequenciaSchools'
                    // '/user/social-profile/posts'
                },
                {
                    id: 'turma1',
                    title: ["5. ",<FormattedMessage id="turmas" />],
                    type: 'item',
                    url: '/turma'
                    // '/user/social-profile/posts'
                },

                {
                    id: 'option_',
                    title:  ["6. ", <FormattedMessage id="options" />],
                    type: 'item',
                    url: '/options'
                },
                {
                    id: 'enregistrerCours',
                    title: ["7. ",<FormattedMessage id="enregistrer_cours" />],
                    type: 'item',
                    url: '/cours/enregistrercoursSchools'
                    // '/user/social-profile/posts'
                },

               /*   {
                    id: 'type_inscription_normal_attribuer_cours_etudiant1',
                    title: ["8. ", <FormattedMessage id="type_inscription_normal_attribuer_cours_etudiant" />],
                    type: 'item',
                    url: '/cours/coursSpeciaux'
                    // '/user/social-profile/posts'
                }, */
                {
                    id: 'listCours1',
                    title: ["8. ", <FormattedMessage id="liste_cours" />],
                    type: 'item',
                    url: '/cours/coursListSchools'
                    // '/user/social-profile/posts'
                },

                {
                    id: 'coursPlan1',
                    title: ["9. ",<FormattedMessage id="plandu_cours" />],
                    type: 'item',
                    url: '/cours/coursPlanSchools'
                },

              /*   {
                    id: 'correctionCours',
                    title: ["9. ", <FormattedMessage id="correctionDesCoursForm" />],
                    type: 'item',
                    url: '/cours/coursManquants'
                }, */


               /*  {
                    id: 'baseCalculsPoint1',
                    title: <FormattedMessage id="baseCalculsPoint1" />,
                    type: 'item',
                    url: '/point-base-calcul-points'
                    // '/user/social-profile/posts'
                },
                {
                    id: 'formuleCalculPoints1',
                    title: <FormattedMessage id="formuleCalculPoints1" />,
                    type: 'item',
                    url: '/points/formues-calculs'
                    // '/user/social-profile/posts'
                },

                {
                    id: "deliberation_gestion1",
                    title: <FormattedMessage id="deliberation_gestion" />,
                    type: "collapse",
                    icon: icons.IconBasket,
                    children: [
                        {
                            id: 'mentions_deliberation1',
                            title: <FormattedMessage id="mentions_deliberation_session1" />,
                            type: 'item',
                            url: '/cours/mention-deliberations'
                            // '/user/social-profile/posts'
                        },
                        {
                            id: 'mentions_deliberation2',
                            title: <FormattedMessage id="mentions_deliberation_session2" />,
                            type: 'item',
                            url: '#'
                            // '/user/social-profile/posts'
                        },
                        {
                            id: 'ficheCotationSession1_1',
                            title: <FormattedMessage id="ficheCotationSession1" />,
                            type: 'item',
                            url: '/cours/fichecotation/session1'
                            // '/user/social-profile/posts'
                        },
        
                        
                        {
                            id: 'Pautageralpourcentageentre',
                            title: <FormattedMessage id="pautageral_pourcentage_entre_titre" />,
                            type: 'item',
                            url: '/cours-grille-pourcentage-statistiques'
                        },
                        {
                            id: 'deliberation_premiere_session1',
                            title: <FormattedMessage id="deliberation_premiere_session" />,
                            type: 'item',
                            url: '/cours/deliberation-session1'
                            // '/user/social-profile/posts'
                        },
                        {
                            id: 'deliberation_inscriptions_speciales1',
                            title: <FormattedMessage id="deliberation_inscriptions_speciales" />,
                            type: 'item',
                            url: '/cours/deliberation_inscriptions_speciales'
                            // '/user/social-profile/posts'
                        },
                        {
                            id: 'deliberation_deuxième_session1',
                            title: <FormattedMessage id="deliberation_deuxième_session" />,
                            type: 'item',
                            url: '#'
                            // '/user/social-profile/posts'
                        },
                    ],
                  },
                
                {
                    id: 'controle_enregistrement_point1',
                    title: <FormattedMessage id="controle_enregistrement_point1" />,
                    type: 'item',
                    url: '/controle-enreistrment-points'
                },
                {
                    id: "cours_administration1",
                    title: <FormattedMessage id="cours_administration" />,
                    type: "collapse",
                    icon: icons.IconBasket,
                    children: [
                        {
                            id: 'correctionCours',
                            title: <FormattedMessage id="correctionDesCoursForm" />,
                            type: 'item',
                            url: '/correct-cours/form'
                        },
                        {
                            id: 'courrigerStudentCoursManquant1',
                            title: <FormattedMessage id="courrigerStudentCoursManquant" />,
                            type: 'item',
                            url: '/correct-cours/manquants'
                        }, */
                    
                   // ],
                //  },
                
        
    ]
};

export default cours;
